import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "../directory/Directory.css";

const Directory = () => {
  const [editingType, setEditingType] = useState(null);
  const [editingName, setEditingName] = useState(null);
  const [editingPackage, setEditingPackage] = useState(null);
  const [newName, setNewName] = useState('');
  const [contractors, setContractors] = useState([]);
  const [expandedId, setExpandedId] = useState(null);
  const [contractorRestaurants, setContractorRestaurants] = useState([]);
  const [expandedRestaurantId, setExpandedRestaurantId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [contractorType, setContractorType] = useState(null);
  const [contractorUsers, setContractorUsers] = useState([]);
  const [selectedContractor, setSelectedContractor] = useState(null);
  const [contractorEmails, setContractorEmails] = useState([]);
  const [showAddEmail, setShowAddEmail] = useState(false);
  const [newEmail, setNewEmail] = useState('');
  const [editingGroupName, setEditingGroupName] = useState(null);
  const [newGroupName, setNewGroupName] = useState('');
  const [selectedSource, setSelectedSource] = useState('');
  const [source, setSource] = useState('');
  const [sourceLoaded, setSourceLoaded] = useState(false);
  const [commissionCfg, setCommissionCfg] = useState(null);
  
  const [fopData, setFopData] = useState({
    name_fop: '',
    contractor_id: '',
    rest_id: '',
    edrpou: '',
    user_id_ch: localStorage.getItem('userId')
  });
  const [commissionConfig, setCommissionConfig] = useState(null);
  const [userRegions, setUserRegions] = useState({});
  const [userRoles, setUserRoles] = useState({});

  const roleOptions = [
    { value: 'Координатор', label: 'Координатор' },
    { value: 'Ментор', label: 'Ментор' },
    { value: 'Черговий', label: 'Черговий' },
    { value: 'Тімлід', label: 'Тімлід' }
  ];

  const sourceOptions = ['Dao', 'IT Gurman', 'RSC', 'Інші'];

  const accessRightsLabels = {
    '1': 'Обмеження',
    '2': 'Зняття обмеження'
  };

  const regionLabels = {
    'uk-UA': 'Україна',
    'pl-PL': 'Польща'
  };

  const pacOptions = {
    solo: [
      { label: 'BASIC', value: 'BASIC', limit: 3 },
      { label: 'START', value: 'START', limit: 10 },
      { label: 'PRO', value: 'PRO', limit: 20 },
      { label: 'EXCLUSIVE', value: 'EXCLUSIVE', limit: 50 }
    ],
    chain: [
      { label: 'BASIC', value: 'BASIC', limit: 3 },
      { label: 'START', value: 'START', limit: 10 },
      { label: 'PRO', value: 'PRO', limit: 20 },
      { label: 'EXCLUSIVE', value: 'EXCLUSIVE', limit: 50 }
    ]
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('https://hub2.daolog.net/contractors-with-users-and-restaurants');
        const fopCountResponse = await axios.get('https://hub2.daolog.net/contractors-with-fop-count');
        const fopCountAmResponse = await axios.get('https://hub2.daolog.net/contractors-with-fop-count-am');
        
        const contractorsWithFopCount = response.data.map(contractor => {
          const fopCountData = fopCountResponse.data.find(fc => fc.id === contractor.id);
          const fopCountAmData = fopCountAmResponse.data.find(fc => fc.id === contractor.id);
          return {
            ...contractor,
            current_fop_count: fopCountData ? fopCountData.current_fop_count : 0,
            current_fop_count_am: fopCountAmData ? fopCountAmData.current_fop_count : 0,
            fop_amount: fopCountData ? fopCountData.fop_amount : 0,
            pac: contractor.pac || 'BASIC'
          };
        });
        
        setContractors(contractorsWithFopCount);
      } catch (error) {
        console.error('Помилка отримання даних:', error);
      }
    };
    fetchData();
  }, []);

  const fetchUserRoles = async (userIds) => {
    try {
      console.log('Завантаження ролей для користувачів:', userIds);
      const response = await axios.post('https://hub2.daolog.net/users-roles', {
        userIds: userIds
      });
      console.log('Отримано ролі:', response.data);
      setUserRoles(response.data);
    } catch (error) {
      console.error('Помилка отримання ролей користувачів:', error);
      const defaultRoles = {};
      userIds.forEach(userId => {
        defaultRoles[userId] = 'Черговий';
      });
      setUserRoles(defaultRoles);
    }
  };

  const handleRoleChange = async (userId, newRole) => {
    try {
      console.log('Оновлення ролі для користувача:', userId, 'Нова роль:', newRole);
      await axios.put(`https://hub2.daolog.net/update-user-role/${userId}`, {
        role: newRole
      });
      
      setUserRoles(prev => ({
        ...prev,
        [userId]: newRole
      }));
      
      console.log('Роль успішно оновлена');
    } catch (error) {
      console.error('Error updating role:', error);
      alert('Помилка при оновленні ролі');
    }
  };

  const handleContractorClick = async (contractor) => {
    if (expandedId === contractor.id) {
      setExpandedId(null);
      setExpandedRestaurantId(null);
      setContractorType(null);
      setContractorUsers([]);
      setContractorEmails([]);
      setSourceLoaded(false);
      setUserRoles({});
    } else {
      setExpandedId(contractor.id);
      setExpandedRestaurantId(null);
      try {
        console.log('Завантаження даних для контрагента:', contractor.id);
        
        const [restaurantsResponse, typeResponse, usersResponse, sourceResponse] = await Promise.all([
          axios.get(`https://hub2.daolog.net/contractor-restaurants-with-fops/${contractor.id}`),
          axios.get(`https://hub2.daolog.net/contractor-type/${contractor.id}`),
          axios.get(`https://hub2.daolog.net/contractor-users/${contractor.id}`),
          axios.get(`https://hub2.daolog.net/contractor-source/${contractor.id}`)
        ]);
        
        console.log('Дані ресторанів:', restaurantsResponse.data);
        console.log('Тип контрагента:', typeResponse.data);
        console.log('Користувачі:', usersResponse.data);
        console.log('Джерело:', sourceResponse.data);
        
        setContractorRestaurants(restaurantsResponse.data);
        setContractorType(typeResponse.data.type);
        setContractorUsers(usersResponse.data);
        setSource(sourceResponse.data.source || '');
        setSourceLoaded(true);
        
        const userIds = usersResponse.data.map(user => user.id);
        console.log('ID користувачів для завантаження ролей:', userIds);
        
        if (userIds.length > 0) {
          await fetchUserRoles(userIds);
        } else {
          console.log('Немає користувачів для завантаження ролей');
        }
        
      } catch (err) {
        console.error('Error fetching contractor data:', err);
        try {
          const usersResponse = await axios.get(`https://hub2.daolog.net/contractor-users/${contractor.id}`);
          console.log('Користувачі (окремий запит):', usersResponse.data);
          setContractorUsers(usersResponse.data);
        } catch (userError) {
          console.error('Error fetching users separately:', userError);
        }
      }
    }
  };
  const handleNameEdit = (contractor) => {
    setEditingName(contractor.id);
    setNewName(contractor.name);
  };

  const handleGroupNameEdit = (contractor) => {
    setEditingGroupName(contractor.id);
    setNewGroupName(contractor.group_name || '');
  };

  const handleSourceChange = async (value) => {
    setSource(value); 
    try {
      await axios.put('https://hub2.daolog.net/update-contractor-source', {
        contractorId: expandedId,
        source: value
      });
    } catch (error) {
      console.error('Помилка оновлення джерела:', error);
      setSource(source); 
    }
  };
  
  const handleGroupNameSave = async (contractorId) => {
    try {
      const response = await axios.put(`https://hub2.daolog.net/contractor-group-name/${contractorId}`, {
        group_name: newGroupName
      });
      
      setContractors(prevContractors => 
        prevContractors.map(contractor => {
          if (contractor.id === contractorId) {
            return {
              ...contractor,
              group_name: response.data.group_name
            };
          }
          return contractor;
        })
      );
      
      setEditingGroupName(null);
      setNewGroupName('');
    } catch (err) {
      console.error('Error updating group name:', err);
    }
  };

  const handleNameSave = async (contractorId) => {
    try {
      await axios.put(`https://hub2.daolog.net/contractor-name/${contractorId}`, {
        name: newName
      });
      
      setContractors(prevContractors => 
        prevContractors.map(contractor => {
          if (contractor.id === contractorId) {
            return {
              ...contractor,
              name: newName
            };
          }
          return contractor;
        })
      );
      
      setEditingName(null);
      setNewName('');
    } catch (err) {
      console.error('Error updating contractor name:', err);
    }
  };

  const handleTypeChange = async (contractorId, newType) => {
    try {
      const response = await axios.put(`https://hub2.daolog.net/contractor-type/${contractorId}`, {
        type: newType ? 'chain' : 'solo'
      });
      
      setContractorType(newType ? 'chain' : 'solo');
      setEditingType(null);
      
      setContractors(prevContractors => 
        prevContractors.map(contractor => {
          if (contractor.id === contractorId) {
            const defaultPac = 'BASIC';
            const defaultLimit = (newType ? pacOptions.chain : pacOptions.solo)
              .find(opt => opt.value === defaultPac)?.limit || 3;
            
            return {
              ...contractor,
              type: newType ? 'chain' : 'solo',
              fop_amount: defaultLimit,
              pac: defaultPac
            };
          }
          return contractor;
        })
      );
      
    } catch (err) {
      console.error('Error updating contractor type:', err);
    }
  };

  const handleRestaurantClick = (restaurantId) => {
    if (expandedRestaurantId === restaurantId) {
      setExpandedRestaurantId(null);
    } else {
      setExpandedRestaurantId(restaurantId);
    }
  };

  const getSubscriptionType = (fopAmount, isChain) => {
    const options = isChain ? pacOptions.chain : pacOptions.solo;
    const option = options.find(opt => opt.limit === fopAmount) || options[0]; 
    return `${option.value} (до ${option.limit}х контрагентів одночасно)`;
  };

  const filteredContractors = contractors.filter(contractor =>
    contractor.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', maxWidth: '800px', margin: '0 auto'}}>
      <h1 style={{ color: '#333', borderBottom: '2px solid #333', paddingBottom: '10px' }}>Довідник</h1>
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <input
          type="text"
          placeholder="Пошук"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            padding: '10px',
            width: '300px',
            borderRadius: '5px',
            border: '1px solid #ddd',
            fontSize: '16px'
          }}
        />
      </div>
      
      {filteredContractors.map((contractor) => (
        <div key={contractor.id} className="contractor-container">
          <div 
            className="contractor-header"
            onClick={() => handleContractorClick(contractor)}
            style={{ textAlign: 'center', position: 'relative', cursor: 'pointer', padding: '15px', backgroundColor: '#f5f5f5', margin: '10px 0', borderRadius: '5px' }}
          >
            {editingName === contractor.id ? (
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: '10px' }} onClick={(e) => e.stopPropagation()}>
                <input
                  type="text"
                  value={newName}
                  onChange={(e) => setNewName(e.target.value)}
                  style={{ padding: '5px' }}
                />
                <button
                  onClick={() => handleNameSave(contractor.id)}
                  style={{
                    padding: '5px 10px',
                    fontSize: '12px',
                    cursor: 'pointer',
                    marginRight: '5px'
                  }}
                >
                  Зберегти
                </button>
                <button
                  onClick={() => {
                    setEditingName(null);
                    setNewName('');
                  }}
                  style={{
                    padding: '5px 10px',
                    fontSize: '12px',
                    cursor: 'pointer'
                  }}
                >
                  Скасувати
                </button>
              </div>
            ) : (
              <>
                <span style={{ fontSize: '18px', fontWeight: 'bold' }}>{contractor.name}</span>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleNameEdit(contractor);
                  }}
                  style={{
                    position: 'absolute',
                    right: '20px',
                    padding: '5px 10px',
                    fontSize: '12px',
                    cursor: 'pointer'
                  }}
                >
                  Змінити
                </button>
              </>
            )}
          </div>
          
          {expandedId === contractor.id && (
            <div className="contractor-details" style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '5px', marginBottom: '20px' }}>
              <div className="info-section">
                <h3>Інформація про cпівробітників</h3>
               
                
                <p><strong>Назва:</strong> {contractor.name}</p>
                
                

                

                {/* Секція користувачів та їх ролей */}
                <div style={{ marginTop: '20px' }}>
                  <h4>Користувачі та їх ролі:</h4>
                  {contractorUsers && contractorUsers.length > 0 ? (
                    contractorUsers.map((user) => (
                      <div key={user.id} style={{ 
                        marginLeft: '20px', 
                        marginTop: '10px', 
                        padding: '10px', 
                        border: '1px solid #ddd', 
                        borderRadius: '5px',
                        backgroundColor: 'white'
                      }}>
                        <div style={{ marginBottom: '8px' }}>
                          <strong>{user.username}</strong> 
                          {user.email && <span> ({user.email})</span>}
                        </div>
                        <div>
                          <span style={{ marginRight: '10px' }}>Роль: </span>
                          <select
                            value={userRoles[user.id] || 'Черговий'}
                            onChange={(e) => handleRoleChange(user.id, e.target.value)}
                            style={{ padding: '5px', minWidth: '150px' }}
                          >
                            {roleOptions.map(option => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                          <span style={{ marginLeft: '10px', color: '#666' }}>
                            Поточна роль: {userRoles[user.id] || 'Черговий'}
                          </span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p style={{ marginLeft: '20px', color: '#666' }}>Користувачі не знайдені</p>
                  )}
                </div>
      
   



    


                
              </div>


            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Directory;

